import { render, staticRenderFns } from "./UgiDetailsFieldWithTitle.vue?vue&type=template&id=264b140e&scoped=true&"
import script from "./UgiDetailsFieldWithTitle.vue?vue&type=script&lang=js&"
export * from "./UgiDetailsFieldWithTitle.vue?vue&type=script&lang=js&"
import style0 from "./UgiDetailsFieldWithTitle.vue?vue&type=style&index=0&id=264b140e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264b140e",
  null
  
)

export default component.exports